const REQUEST_TYPE = 'sbz_request_2039402'
const RESPONSE_TYPE = 'sbz_response_204980'

const isFunction = f => f && {}.toString.call(f) === '[object Function]'

export class Server {
	constructor (server_name, handler) {
		this.server_name = server_name
		this.handler = handler || {}

		window.addEventListener('message', async e => {
			let mes = {}
			try {
				mes = JSON.parse(e.data)
			} catch (err) {}

			if (mes.type !== REQUEST_TYPE) return
			if (mes.server !== this.server_name) return

			let param = mes.param || ''
			let f = this.handler[mes.method]
			let res, err
			if (isFunction(f)) {
				try {
					res = await this.handler[mes.method](...param)
				} catch (e) {
					err = e
				}
			}

			// e.source is the window object that sent the message
			e.source.postMessage(
				JSON.stringify({
					type: RESPONSE_TYPE,
					request_id: mes.request_id,
					data: res,
					err: err,
				}),
				'*'
			)
		})
	}
}

function random_str (size, prefix) {
	if (size <= 0) size = 30
	var s = ''
	var random_ascii
	for (var i = 0; i < size; i++) {
		random_ascii = Math.floor(Math.random() * 25 + 97)
		s += String.fromCharCode(random_ascii)
	}
	return prefix + s
}

export class Client {
	//iframe.contentWindow
	constructor (server_name, server) {
		this.server_name = server_name
		this.server = server

		this.requests = {}

		window.addEventListener('message', e => {
			var mes = {}
			try {
				mes = JSON.parse(e.data)
			} catch (err) {}

			// only accept requests from within the iframe
			if (mes.type !== RESPONSE_TYPE) return

			var req = this.requests[mes.request_id]
			delete this.requests[mes.request_id]
			if (!req || !req.rs) return
			req.rs(mes.data)
		})
	}

	call (method, ...param) {
		return new Promise(rs => {
			var request_id = random_str(20, 'wtreq')
			this.requests[request_id] = { rs }
			this.server.postMessage(
				JSON.stringify({
					server: this.server_name,
					request_id: request_id,
					type: REQUEST_TYPE,
					method: method,
					param: param,
				}),
				'*'
			)

			// abort operation and return error if service worker doesn't return
			// in 30 sec
			setTimeout(() => {
				var req = this.requests[request_id]
				delete this.requests[request_id]
				if (!req) return // ignore if response is returned before timeout
				if (rs) rs(new Error('timeout'))
			}, 30000)
		})
	}
}
